














































































































import { Component, Prop } from 'nuxt-property-decorator';
import IAElementComponent from './IAElementComponent.vue';
import { IaElementsInterface } from '@/types/contentContract';

@Component({
  name: 'MatchQuestionAndAnswer'
})
export default class MatchQuestionAndAnswer extends IAElementComponent {
  @Prop({ type: Object, default: () => [] })
  template!: IaElementsInterface;

  findAnswer(index: number): string {
    const hasAnswer = this.answers.find((a) => {
      return a.id === index;
    });

    if (hasAnswer !== undefined) {
      return hasAnswer.answer;
    }

    return '';
  }

  choseQuestion(event, index: number): void {
    this.$refs.questions.forEach((elm) => {
      elm.parentElement.style.background = 'transparent';
    });
    event.currentTarget.parentElement.style.background = '#eeeeee';

    this.activeIndex = index;
  }

  chooseAnswer(event, index: number, answer: string): void {
    event.currentTarget.parentElement.style.background = '#eeeeee';
    this.activeValue = answer;

    const obj: { answer: string; id: number } = {
      answer,
      id: this.activeIndex
    };
    if (!this.answers.some((event) => event.id === this.activeIndex)) {
      this.answers.push(obj);
    } else {
      // Array needs to find the object that contains the active index already, so it knows what to change.
      this.answers[this.answers.findIndex((el) => el.id === this.activeIndex)] =
        obj;
      this.answers.push();
    }
  }

  removeAnswers(): void {
    this.answers = [];
    this.isValidated = false;
    this.$refs.questions.forEach((elm) => {
      elm.parentElement.style.background = 'transparent';
    });
    this.$refs.answers.forEach((elm) => {
      elm.parentElement.style.background = 'transparent';
    });
  }
}
